module.exports = __webpack_public_path__ + "img/5.2f4d0465.svg";